import { Box, Text } from "@chakra-ui/react"

/** Default blocks error UI when consumer does not provide renderError. Simple centered message. */
export const DefaultError = ({ message }: { message: string }) => (
  <Box
    minH="300px"
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    px={4}
  >
    <Text color="red.600" textAlign="center" fontSize="lg">
      {message}
    </Text>
  </Box>
)
